"use strict";
import { ReactComponent as FlowLogo } from "assets/svg/flow.svg";
import HolidayUniIcon from "components/Logo/HolidayUniIcon";
import styled from "lib/styled-components";
function Logo({ onClick }) {
  return <FlowLogo height="40" onClick={onClick} />;
}
const Container = styled.div`
  position: relative;
  cursor: ${({ clickable }) => clickable ? "pointer" : "auto"};
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const NavIcon = ({ clickable, onClick, ...props }) => <Container clickable={clickable}>{HolidayUniIcon(props) !== null ? <HolidayUniIcon {...props} /> : <Logo onClick={onClick} />}</Container>;
